/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgStatusTracker = (props)=>/*#__PURE__*/ React.createElement("svg", {
        width: "1em",
        height: "1em",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M12 3a8.98 8.98 0 0 1 3.164.572l-1.183 1.192a7.5 7.5 0 1 0 5.276 5.335l1.194-1.203C20.806 9.864 21 10.91 21 12a9 9 0 1 1-9-9Zm9.06-.328.146.136a2.763 2.763 0 0 1 .008 3.9l-6.304 6.354a1.5 1.5 0 0 1-.652.385l-4.212 1.209a.5.5 0 0 1-.618-.619l1.21-4.22a1.5 1.5 0 0 1 .377-.642l6.309-6.36a2.74 2.74 0 0 1 3.736-.143Zm-2.671 1.2-6.31 6.36-.712 2.484 2.478-.71 6.304-6.355c.457-.461.486-1.186.088-1.68l-.095-.107a1.24 1.24 0 0 0-1.753.007Z"
    }));
export default SvgStatusTracker;
